import type { Repair } from '@/types/repair';

export const repairs: Repair[] = [
  {
    id: 'R-0042',
    customerId: 'C001',
    customer: 'Kwame Asante',
    customerEmail: 'kwame.a@email.com',
    customerPhone: '+233 24 123 4567',
    device: 'iPhone 14 Pro Max',
    deviceType: 'iPhone',
    issue: 'Screen replacement + battery',
    status: 'ready',
    jobType: 'diagnosis_to_repair',
    serviceStage: 'pickup',
    quoteStatus: 'approved',
    diagnosisSummary: 'Screen assembly shattered on impact. Battery health at 78% and recommended for replacement.',
    diagnosisFee: 200,
    diagnosisPaidAt: '2026-04-20T09:15:00.000Z',
    quoteAmount: 850,
    quoteSentAt: '2026-04-20T12:10:00.000Z',
    approvalDecisionAt: '2026-04-20T13:00:00.000Z',
    repairStartedAt: '2026-04-21T09:00:00.000Z',
    technicians: [{ id: 'tech-ama', name: 'Ama O.' }],
    eta: 'Today',
    cost: 'GHS 850',
    costNum: 850,
    started: '2026-04-20',
    warranty: true,
    parts: [{ name: 'OLED Display', status: 'installed' }, { name: 'Battery', status: 'installed' }],
    notes: ['Screen cracked from drop. Battery at 78% health.', 'Customer approved both repairs.'],
    payments: [
      { id: 'PAY-R42-1', type: 'diagnosis_fee', amount: 200, amountLabel: 'GHS 200', status: 'paid', paidAt: '2026-04-20T09:15:00.000Z' },
      { id: 'PAY-R42-2', type: 'repair_full', amount: 850, amountLabel: 'GHS 850', status: 'paid', paidAt: '2026-04-22T15:30:00.000Z' },
    ],
  },
  {
    id: 'R-0041',
    customerId: 'C002',
    customer: 'Ama Owusu',
    customerEmail: 'ama.owusu@email.com',
    customerPhone: '+233 20 987 6543',
    device: 'MacBook Air M2',
    deviceType: 'MacBook',
    issue: 'Keyboard not responding',
    status: 'in_progress',
    jobType: 'diagnosis_to_repair',
    serviceStage: 'repair',
    quoteStatus: 'approved',
    diagnosisSummary: 'Liquid damage on top case. Keyboard assembly replacement required.',
    diagnosisFee: 200,
    diagnosisPaidAt: '2026-04-18T10:00:00.000Z',
    quoteAmount: 1200,
    quoteSentAt: '2026-04-18T17:30:00.000Z',
    approvalDecisionAt: '2026-04-19T08:10:00.000Z',
    repairStartedAt: '2026-04-19T10:00:00.000Z',
    technicians: [{ id: 'tech-yaw', name: 'Yaw D.' }],
    eta: 'Apr 24',
    cost: 'GHS 1,200',
    costNum: 1200,
    started: '2026-04-18',
    warranty: false,
    parts: [{ name: 'Top Case Assembly', status: 'ordered' }],
    notes: ['Liquid damage suspected. Diagnosing logic board.', 'Part ordered from supplier — ETA 2 days.'],
    payments: [
      { id: 'PAY-R41-1', type: 'diagnosis_fee', amount: 200, amountLabel: 'GHS 200', status: 'paid', paidAt: '2026-04-18T10:00:00.000Z' },
      { id: 'PAY-R41-2', type: 'repair_deposit', amount: 500, amountLabel: 'GHS 500', status: 'paid', paidAt: '2026-04-19T08:10:00.000Z' },
    ],
  },
  {
    id: 'R-0040',
    customerId: 'C003',
    customer: 'Yaw Darko',
    customerEmail: 'yaw.darko@email.com',
    customerPhone: '+233 54 456 7890',
    device: 'Samsung Galaxy S24',
    deviceType: 'Android',
    issue: 'Charging port loose',
    status: 'awaiting_approval',
    jobType: 'diagnosis_to_repair',
    serviceStage: 'approval',
    quoteStatus: 'pending',
    diagnosisSummary: 'Charging port flex is damaged and needs replacement. Board is intact.',
    diagnosisFee: 200,
    diagnosisPaidAt: '2026-04-19T11:20:00.000Z',
    quoteAmount: 320,
    quoteSentAt: '2026-04-19T16:00:00.000Z',
    technicians: [{ id: 'tech-ama', name: 'Ama O.' }],
    eta: 'Apr 25',
    cost: 'GHS 320',
    costNum: 320,
    started: '2026-04-19',
    warranty: true,
    parts: [{ name: 'Charging Port Flex', status: 'pending' }],
    notes: ['Port physically damaged. Needs replacement.', 'Waiting for customer approval on quote.'],
    payments: [{ id: 'PAY-R40-1', type: 'diagnosis_fee', amount: 200, amountLabel: 'GHS 200', status: 'paid', paidAt: '2026-04-19T11:20:00.000Z' }],
  },
  {
    id: 'R-0039',
    customerId: 'C004',
    customer: 'Abena Frimpong',
    customerEmail: 'abena.f@email.com',
    customerPhone: '+233 27 333 4444',
    device: 'iPhone 13',
    deviceType: 'iPhone',
    issue: 'Back glass cracked',
    status: 'parts_pending',
    jobType: 'diagnosis_to_repair',
    serviceStage: 'repair',
    quoteStatus: 'approved',
    diagnosisSummary: 'Back glass only. Frame unaffected. Part ordered for color match.',
    diagnosisFee: 200,
    diagnosisPaidAt: '2026-04-17T09:50:00.000Z',
    quoteAmount: 450,
    quoteSentAt: '2026-04-17T14:20:00.000Z',
    approvalDecisionAt: '2026-04-17T18:00:00.000Z',
    technicians: [{ id: 'tech-ama', name: 'Ama O.' }],
    eta: 'Apr 26',
    cost: 'GHS 450',
    costNum: 450,
    started: '2026-04-17',
    warranty: false,
    parts: [{ name: 'Back Glass Panel', status: 'ordered' }],
    notes: ['Cosmetic damage only. Phone fully functional.', 'Customer wants original color match.'],
    payments: [{ id: 'PAY-R39-1', type: 'diagnosis_fee', amount: 200, amountLabel: 'GHS 200', status: 'paid', paidAt: '2026-04-17T09:50:00.000Z' }],
  },
  {
    id: 'R-0038',
    customerId: 'C005',
    customer: 'Kofi Mensah',
    customerEmail: 'kofi.m@email.com',
    customerPhone: '+233 24 777 8888',
    device: 'iPad Pro 12.9"',
    deviceType: 'iPad',
    issue: 'No power / won\'t charge',
    status: 'diagnosis_paid',
    jobType: 'diagnosis_only',
    serviceStage: 'diagnosis',
    quoteStatus: 'not_sent',
    diagnosisFee: 200,
    diagnosisPaidAt: '2026-04-22T08:40:00.000Z',
    technicians: [{ id: 'tech-yaw', name: 'Yaw D.' }],
    eta: 'Apr 27',
    cost: 'TBD',
    costNum: 0,
    started: '2026-04-22',
    warranty: true,
    parts: [],
    notes: ['Device completely dead. Needs full diagnostic.', 'Under warranty — no cost to customer.'],
    payments: [{ id: 'PAY-R38-1', type: 'diagnosis_fee', amount: 200, amountLabel: 'GHS 200', status: 'paid', paidAt: '2026-04-22T08:40:00.000Z' }],
  },
  {
    id: 'R-0037',
    customerId: 'C006',
    customer: 'Akosua Boateng',
    customerEmail: 'akosua.b@email.com',
    customerPhone: '+233 20 555 6666',
    device: 'MacBook Pro 14"',
    deviceType: 'MacBook',
    issue: 'Trackpad erratic',
    status: 'ready',
    jobType: 'diagnosis_to_repair',
    serviceStage: 'pickup',
    quoteStatus: 'approved',
    diagnosisSummary: 'Trackpad cable was loose. Re-seat and testing resolved issue.',
    diagnosisFee: 200,
    diagnosisPaidAt: '2026-04-15T09:00:00.000Z',
    quoteAmount: 380,
    quoteSentAt: '2026-04-15T12:00:00.000Z',
    approvalDecisionAt: '2026-04-15T12:30:00.000Z',
    repairStartedAt: '2026-04-15T13:00:00.000Z',
    technicians: [{ id: 'tech-yaw', name: 'Yaw D.' }],
    eta: 'Today',
    cost: 'GHS 380',
    costNum: 380,
    started: '2026-04-15',
    warranty: false,
    parts: [{ name: 'Trackpad Assembly', status: 'installed' }],
    notes: ['Trackpad cable loose. Re-seated and tested.', 'Quality check passed. Ready for pickup.'],
    payments: [{ id: 'PAY-R37-1', type: 'diagnosis_fee', amount: 200, amountLabel: 'GHS 200', status: 'paid', paidAt: '2026-04-15T09:00:00.000Z' }],
  },
  {
    id: 'R-0036',
    customer: 'Nana Ama Sarpong',
    customerEmail: 'nana.s@email.com',
    customerPhone: '+233 54 777 9988',
    device: 'iPhone 15',
    deviceType: 'iPhone',
    issue: 'Face ID not working',
    status: 'in_progress',
    jobType: 'diagnosis_to_repair',
    serviceStage: 'repair',
    quoteStatus: 'approved',
    diagnosisSummary: 'TrueDepth module damaged and requires replacement.',
    diagnosisFee: 200,
    diagnosisPaidAt: '2026-04-21T10:30:00.000Z',
    quoteAmount: 600,
    quoteSentAt: '2026-04-21T14:00:00.000Z',
    approvalDecisionAt: '2026-04-21T17:00:00.000Z',
    repairStartedAt: '2026-04-22T09:15:00.000Z',
    technicians: [{ id: 'tech-ama', name: 'Ama O.' }],
    eta: 'Apr 24',
    cost: 'GHS 600',
    costNum: 600,
    started: '2026-04-21',
    warranty: false,
    parts: [{ name: 'TrueDepth Camera', status: 'ordered' }],
    notes: ['Face ID module damaged. Waiting for genuine part.'],
    payments: [{ id: 'PAY-R36-1', type: 'diagnosis_fee', amount: 200, amountLabel: 'GHS 200', status: 'paid', paidAt: '2026-04-21T10:30:00.000Z' }],
  },
  {
    id: 'R-0035',
    customer: 'Kwabena Appiah',
    customerEmail: 'kwabena.a@email.com',
    customerPhone: '+233 20 000 1122',
    device: 'Dell XPS 15',
    deviceType: 'Windows',
    issue: 'Battery swollen',
    status: 'parts_pending',
    jobType: 'diagnosis_to_repair',
    serviceStage: 'repair',
    quoteStatus: 'approved',
    diagnosisSummary: 'Battery swollen and unsafe. Replacement required urgently.',
    diagnosisFee: 200,
    diagnosisPaidAt: '2026-04-20T11:00:00.000Z',
    quoteAmount: 720,
    quoteSentAt: '2026-04-20T15:30:00.000Z',
    approvalDecisionAt: '2026-04-20T18:20:00.000Z',
    technicians: [{ id: 'tech-yaw', name: 'Yaw D.' }],
    eta: 'Apr 28',
    cost: 'GHS 720',
    costNum: 720,
    started: '2026-04-20',
    warranty: false,
    parts: [{ name: 'Laptop Battery 97Wh', status: 'ordered' }],
    notes: ['Battery causing palm rest to bulge. Urgent replacement.'],
    payments: [{ id: 'PAY-R35-1', type: 'diagnosis_fee', amount: 200, amountLabel: 'GHS 200', status: 'paid', paidAt: '2026-04-20T11:00:00.000Z' }],
  },
  {
    id: 'R-0034',
    customer: 'Efua Asante',
    customerEmail: 'efua.a@email.com',
    customerPhone: '+233 24 200 1000',
    device: 'iPhone 12',
    deviceType: 'iPhone',
    issue: 'Screen cracked',
    status: 'completed',
    jobType: 'diagnosis_to_repair',
    serviceStage: 'closed',
    quoteStatus: 'approved',
    diagnosisFee: 200,
    diagnosisPaidAt: '2026-04-14T09:00:00.000Z',
    quoteAmount: 550,
    approvalDecisionAt: '2026-04-14T11:00:00.000Z',
    technicians: [{ id: 'tech-ama', name: 'Ama O.' }],
    eta: '—',
    cost: 'GHS 550',
    costNum: 550,
    started: '2026-04-14',
    completedDate: '2026-04-17',
    warranty: false,
    parts: [],
    notes: [],
    payments: [{ id: 'PAY-R34-1', type: 'repair_full', amount: 550, amountLabel: 'GHS 550', status: 'paid', paidAt: '2026-04-17T15:00:00.000Z' }],
  },
  {
    id: 'R-0033',
    customer: 'Fiifi Mensah',
    customerEmail: 'fiifi.m@email.com',
    customerPhone: '+233 54 100 2000',
    device: 'Samsung A54',
    deviceType: 'Android',
    issue: 'Speaker not working',
    status: 'diagnosis_only_closed',
    jobType: 'diagnosis_only',
    serviceStage: 'closed',
    quoteStatus: 'declined',
    diagnosisSummary: 'Speaker module failed. Customer declined quoted repair after diagnosis.',
    diagnosisFee: 200,
    diagnosisPaidAt: '2026-04-13T10:10:00.000Z',
    quoteAmount: 280,
    quoteSentAt: '2026-04-13T14:00:00.000Z',
    approvalDecisionAt: '2026-04-14T09:30:00.000Z',
    technicians: [{ id: 'tech-yaw', name: 'Yaw D.' }],
    eta: '—',
    cost: 'GHS 280',
    costNum: 280,
    started: '2026-04-13',
    completedDate: '2026-04-14',
    warranty: false,
    parts: [],
    notes: ['Diagnosis delivered to customer.', 'Customer chose to repair elsewhere.'],
    payments: [{ id: 'PAY-R33-1', type: 'diagnosis_fee', amount: 200, amountLabel: 'GHS 200', status: 'paid', paidAt: '2026-04-13T10:10:00.000Z' }],
  },
];

export const repairStats = [
  { label: 'Active Repairs', value: '8', change: '+2', icon: 'ri-tools-line', accent: 'bg-blue-500' },
  { label: 'Ready for Pickup', value: '2', change: '+1', icon: 'ri-check-double-line', accent: 'bg-emerald-500' },
  { label: 'Avg Turnaround', value: '3.2 days', change: '-0.4', icon: 'ri-time-line', accent: 'bg-amber-500' },
  { label: 'Pending Approval', value: '1', change: '0', icon: 'ri-hourglass-line', accent: 'bg-red-500' },
];
